/**
 * Replaces each word's first letter to be upper case.
 * @param text Text to be formatted into title case
 * @returns Title case formatted text
 */
export default function formatTitleCase(text: string): string {
  return (
    text
      .toLowerCase()
      // regex to grab first letter of each word
      .replace(/(^|\s)\S/g, (firstLetter) => firstLetter.toLocaleUpperCase())
  );
}
